import { Routes } from 'react-router-dom';
import { renderRoute } from '../../config/renderRoute';
import { routeConfig } from '../../config/routeConfig';

export const RouterProvider = () => <Routes>{routeConfig.map(renderRoute)}</Routes>;
